module.exports = __webpack_public_path__ + "static/media/driverA.d9555337.png";